import {
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Button,
  Box,
  HStack,
  Text
} from '@chakra-ui/react';
import { ChevronDownIcon } from '@chakra-ui/icons';
import { UserRole } from 'models/User/User';

export interface UserRoleDropdownProps {
  value?: UserRole;
  onChange: (role?: UserRole) => void;
  size?: string;
  allowEmpty?: boolean;
}

const getRoleColor = (role?: UserRole): string => {
  if (!role) return 'gray.500';
  switch (role) {
    case UserRole.ADMIN:
      return 'purple.500';
    case UserRole.BASIC_ADMIN:
      return 'blue.500';
    case UserRole.BASIC:
      return 'red.500';
    case UserRole.USER:
      return 'cyan.500';
    default:
      return 'gray.500';
  }
};

const RoleOption = ({ role }: { role?: UserRole }) => (
  <HStack spacing={2}>
    <Box
      width="8px"
      height="8px"
      borderRadius="full"
      backgroundColor={getRoleColor(role)}
    />
    <Text>{role || 'All Roles'}</Text>
  </HStack>
);

export default function UserRoleDropdown({
  value,
  onChange,
  size = 'md',
  allowEmpty = true
}: UserRoleDropdownProps) {
  const handleRoleClick = (role?: UserRole) => {
    onChange(role);
  };

  return (
    <Menu>
      <MenuButton
        as={Button}
        rightIcon={<ChevronDownIcon />}
        size={size}
        textAlign="left"
        width="100%"
      >
        <RoleOption role={value} />
      </MenuButton>
      <MenuList>
        {allowEmpty && (
          <MenuItem onClick={() => handleRoleClick(undefined)}>
            <RoleOption role={undefined} />
          </MenuItem>
        )}
        {Object.values(UserRole).map(role => (
          <MenuItem key={role} onClick={() => handleRoleClick(role)}>
            <RoleOption role={role} />
          </MenuItem>
        ))}
      </MenuList>
    </Menu>
  );
}
